import { MouseEvent } from 'react';

interface Props {
    title: string;
    onClick?: (e: MouseEvent) => void;
    onSubmit?: () => void;
    loading?: boolean;
    disabled?: boolean;
    className?: string;
    type?: 'submit' | 'button';
}

export default function Button(props: Props) {
    const onClick = (e: MouseEvent) => {
        props.onClick && props.onClick(e);
    };

    return (
        <div
            onClick={onClick}
            className={`btn-accent relative flex h-8 w-full cursor-pointer flex-col justify-center ${props.disabled ? 'bg-gray-300' : ''} ${props.className || ''}`}
        >
            <button disabled={props.disabled}>{!props.loading && props.title}</button>
            {props.loading && (
                <div className="translate-1/2 absolute left-1/2 top-1/2 h-5 w-5 -translate-x-1/2 -translate-y-1/2 bg-spinner bg-contain" />
            )}
        </div>
    );
}
